import React from 'react';
import Glob from "./libs/Glob.mjs";
import ReactDOM from 'react-dom/client';
import "./media/css/Global.css";
import App from './App.mjs';
import reportWebVitals from './reportWebVitals';
import appBootstrapSetup from "./libs/appBootstrapSetup.mjs";

await appBootstrapSetup();

ReactDOM.createRoot(
    window.document.getElementById(Glob.prop.appRootNode)
).render(
    <React.StrictMode>
        <App/>
    </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
